import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PreviousPageCapturePolicyBksService {
  private urlHistory: string[] = [];
  previousPageName: string = '';

  constructor() {}

  // Store page name if needed
  set setPrevieousPage(value: any) {
    this.previousPageName = value;
  }

  get getPreviousPage() {
    return this.previousPageName;
  }

  // Store current URL in history
  setCurrentUrl(url: string) {
    if (url) {
      this.urlHistory.push(url);

      // Optional: keep only last 10 routes
      if (this.urlHistory.length > 10) {
        this.urlHistory.shift();
      }
    }
  }

  // Current URL
  get getCurrentUrl(): string {
    return this.urlHistory[this.urlHistory.length - 1] || '';
  }

  // 1 step back
  get getPreviousUrl(): string {
    return this.urlHistory[this.urlHistory.length - 2] || '';
  }

  // 2 step back
  get getTwoStepBackUrl(): string {
    return this.urlHistory[this.urlHistory.length - 3] || '';
  }

  get getThreeStepBackUrl(): string {
    return this.urlHistory[this.urlHistory.length - 4] || '';
  }
}
